module.exports = "./images/06_shopgate.jpg";